
const userAgent:string = (navigator && navigator.userAgent) || '';
const vendor = (navigator && navigator.vendor) || '';

// @ts-expect-error
const supportsEncodedStreams = !!(RTCRtpSender?.prototype?.createEncodedStreams);
const supportsRtpScriptTransform = !!(window?.RTCRtpScriptTransform);
const isFirefox = userAgent.includes('Firefox');
const isSafari = !isFirefox && vendor.includes('Apple');
const isEdge = !isFirefox && !isSafari && userAgent.includes('Edg');
const isChrome = !isFirefox && !isSafari && !isEdge && userAgent.includes('Chrome');
// @ts-expect-error userAgentData is still experimental and not generally available
const platform = navigator?.userAgentData?.platform || navigator?.platform || '';
const isWindows = (platform === 'Windows' || platform === 'Win32');

export const PlatformInfo = {
    supportsEncodedStreams,
    supportsRtpScriptTransform,
    isFirefox,
    isSafari,
    isEdge,
    isChrome,
    platform,
    isWindows
}